// @flow
import React from 'react';

import Avatar from 'app/common/ui/Avatar';
import OveflowedText from 'app/common/components/OveflowedText';

import styles from './StudentItem.scss';


type Props = {
  id: number,
  title: string,
  klass: string,
  photo: string,
  gender: string,
  selected?: boolean,
}

const StudentItem = ({ title, klass, photo, gender }: Props) => (
  <span className={styles.root}>
    <Avatar gender={gender} src={photo} className={styles.avatar} />
    <OveflowedText className={styles.title}>{title}</OveflowedText>
    <OveflowedText className={styles.klass}>{klass}</OveflowedText>
  </span>
);

export default StudentItem;
